// Dónde van las sugerencias de un turno —
// ADR-2026-10-05-las-sugerencias-van-al-final-del-turno.
//
// `sugerir_acciones` es una herramienta silenciosa que cuelga sus chips del mensaje del
// asistente que es ÚLTIMO en el momento en que resuelve. Pero cada ronda del motor abre
// un mensaje nuevo del asistente (`useV2Chat`: el texto de la ronda 2 va debajo de las
// cards de la ronda 1), así que cuando el agente llama a la herramienta junto con otras
// y después sigue escribiendo, los chips quedaban en el MEDIO del turno. Acá se decide,
// puro, en qué mensaje dibujarlos: siempre después del último del asistente del turno,
// con las sugerencias de la última que las tiene. Un turno anterior no muestra las
// suyas: son continuaciones para lo que acaba de pasar, no un historial.

export interface SugerenciasDelTurno {
  /** Índice del mensaje del asistente debajo del cual se dibujan. */
  indice: number;
  sugerencias: string[];
}

export function sugerenciasDelTurno(
  mensajes: readonly { role: string; sugerencias?: string[] }[],
): SugerenciasDelTurno | null {
  let ultimoAssistant = -1;
  let sugerencias: string[] | null = null;
  for (let i = mensajes.length - 1; i >= 0; i -= 1) {
    const m = mensajes[i];
    if (m.role === 'user') break;
    if (m.role !== 'assistant') continue;
    if (ultimoAssistant < 0) ultimoAssistant = i;
    if (!sugerencias && m.sugerencias && m.sugerencias.length > 0) sugerencias = m.sugerencias;
  }
  if (ultimoAssistant < 0 || !sugerencias) return null;
  return { indice: ultimoAssistant, sugerencias };
}
